import styled from 'styled-components';
import Button from '@catalogo/ui-americanas-desktop-button';

export const ReviewPageLink = styled(Button)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  padding: 10px 16px;
  line-height: 20px;
  background: ${({ theme }) => theme.primaryColor};
  color: #ffffff;
  font-size: ${({ theme }) => theme.fontSize.sm};
  border: 2px solid ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: 700;

  & :hover {
    color: #ffffff;
  }
`;
